import { combineReducers } from '@reduxjs/toolkit'

import list from './listSlice'
import dashboard from './dashboardSlice'
import admins from './adminsSlice'
import roles from './rolesSlice'
import users from './usersSlice'
import customers from './customersSlice'
import inspectors from './inspectorsSlice'
import projects from './projectsSlice'
import transformers from './transformersSlice'
import testTypes from './testTypesSlice'
import transformerTests from './transformerTestsSlice'
import tests from './testsSlice'
import transReports from './transReportsSlice'
import feedbacks from './feedbacksSlice'
import reports from './reports'
import coolingTypes from './coolingTypesSlice'
import referenceStandards from './referenceStandardsSlice'
import windingMaterials from './windingMaterialsSlice'
import equipments from './equipmentsSlice'
import diagrams from './diagramsSlice'
import labSurfaceAreas from './labSurfaceAreasSlice'
import loginHistory from './loginHistorySlice'

const reducer = combineReducers({
    list,
    dashboard,
    admins,
    roles,
    users,
    customers,
    inspectors,
    projects,
    transformers,
    testTypes,
    transformerTests,
    tests,
    transReports,
    feedbacks,
    reports,
    coolingTypes,
    referenceStandards,
    windingMaterials,
    equipments,
    diagrams,
    labSurfaceAreas,
    loginHistory,
})

export default reducer
